"use client";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="ru">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          fontFamily: "system-ui, sans-serif",
          background: "#fafafa",
          color: "#111",
        }}
      >
        <div style={{ maxWidth: 420 }}>
          <h1 style={{ fontSize: 22, marginBottom: 8 }}>
            Критическая ошибка
          </h1>
          <p style={{ color: "#666", marginBottom: 20, lineHeight: 1.5 }}>
            Приложение столкнулось с непредвиденной ошибкой. Попробуйте
            обновить страницу.
          </p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              padding: "10px 20px",
              borderRadius: 8,
              border: "none",
              background: "#0d9488",
              color: "#fff",
              cursor: "pointer",
              fontSize: 15,
            }}
          >
            Обновить
          </button>
        </div>
      </body>
    </html>
  );
}
